/**
 * @description 系统常量配置
 */

export default {
  $CODE: '200',
  /**
   * aes加密密匙
   */
  $AES_KEY: 'BJIMGQ6RMX29U01I',

  /**
   * 签名加密密匙
   */
  $SIGN_KEY: 'N2jcZ7quLZv7R1V8qxc2683yACrC0Ycg',

  /**
   * 业务端编码
   */
  $CLIENT_ID: '2100003',

  /**
   * 品牌号
   */
  $BRAND_CODE: 'ZYQ001'
};



// WEBPACK FOOTER //
// ./src/utils/config.js